<template>
  <DashboardSelect
    v-model="localValue"
    :options="defOptions"
    :placeholder="placeholder"
    :multiple="multiple"
    @input="$emit('input', $event)"
    @change="$emit('change', $event)"
  />
</template>

<script>
import DashboardSelect from './DashboardSelect.vue';
import _sDefinition from "@/services/General/DefinitionService.js";

export default {
  name: 'DashboardDefinition',
  components: { DashboardSelect },
  props: {
    value: { type: [String, Number], default: null },
    def: { type: Number, required: true },
    placeholder: { type: String, default: 'Seleccionar...' },
    multiple: { type: Boolean, default: false }
  },
  data() {
    return {
      items: [],
      localValue: this.value
    };
  },
  computed: {
    defOptions() {
      const opts = [];
      this.items.forEach(item => {
        opts.push({ 
          value: item.DedValue || item.DedDescription,
          label: item.DedDescription 
        });
      });
      return opts;
    }
  },
  watch: {
    value(val) {
      this.localValue = val;
    }
  },
  mounted() {
    this.fetchDefinition();
  },
  methods: {
    fetchDefinition() {
      // Configuracion para cargar la definicion usando el servicio original
      const params = {
        defID: this.def,
        dgrID: 0,
        requestID: this.$fun.getUserID()
      };
      
      this.$http.post(_sDefinition.definitiongroupURL(), {}, { params })
        .then((r) => {
          if (r.status === 200) {
            this.items = r.data;
          }
        })
        .catch((err) => {
          console.error("Error al obtener definición " + this.def, err);
        });
    }
  }
};
</script>
